import "./WhatsApp.css";
import whatsappicono from '../../assets/images/whatsapp-icon.png';

const WhatsApp = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=541154858252"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <img
        src={whatsappicono}
        alt="WhatsApp" />
    </a>
  );
};

export default WhatsApp;